import Vue from 'vue'
import Router from 'vue-router'
// import Home from '@/views/Home/Home'

Vue.use(Router)


export default new Router({
    mode:"history",
    routes: [
    {
      path: '/',
      redirect: '/activity/hotactivity',
    },
    {
      path: '/home',
      name: 'Home',
      component: resolve => require(['@/views/Home/Home'], resolve),
      meta: {
        title: '首页'
      }
    },
    {
      path:'/match/account',
      name:'account',
      component: resolve => require(['@/views/Match/account'], resolve),
    },
    {
      path:'/user/profit',
      name:"Profit",
      component:resolve => require(['@/views/User/profit'], resolve),
      meta: {
        title: '我的收益'
      }
    },
    {
      path:'/user/myteam',
      name:"myteam",
      component:resolve => require(['@/views/User/myteam'], resolve),
      meta: {
        title: '我的团队'
      }
    },
    {
      path:'/match/mymatch',
      name:"Mymatch",
      component:resolve => require(['@/views/Match/mymatch'], resolve),
      meta: {
        title: '我发布的比赛'
      }
    },
    {
      path: '/match/matchview',
      name: 'matchview',
      component: resolve => require(['@/views/Match/matchview'], resolve),
      meta: {
        title: '活动圈比赛'
      }
    },
    {
      path: '/test',
      name: 'test',
      component: resolve => require(['@/views/Match/Sign'], resolve),
      meta: {
        title: 'test'
      }
    },
    {
      path: '/match/matchjoininfo',
      name: 'matchjoininfo',
      component: resolve => require(['@/views/Match/matchjoininfo'], resolve),
      meta: {
        title: '报名信息'
      }
    },
    {
      path: '/match/matchjoin',
      name: 'matchjoin',
      component: resolve => require(['@/views/Match/matchjoin'], resolve),
      meta: {
        title: '比赛报名'
      }
    },
    {
      path: '/match/playerinfo',
      name: 'playerinfo',
      component: resolve => require(['@/views/Match/playerinfo'], resolve),
      meta: {
        title: '选手详情'
      }
    },
    {
      path:'/match/hotmatch',
      name: 'hotmatch',
      component: resolve => require(['@/views/Match/hotmatch'], resolve),
      meta: {
        title: '比赛广场'
      }
    },
    {
      path: '/article/articleview',
      name: 'articleview',
      component: resolve => require(['@/views/Article/articleview'], resolve),
      meta: {
        title: '活动圈文章'
      }
    },
    {
      path: '/article/articleaccount',
      name: 'articleaccount',
      component: resolve => require(['@/views/Article/articleaccount'], resolve),
      meta: {
        title: '文章_个人中心'
      }
    },
    {
      path: '/article/userdata',
      name: 'userdata',
      component: resolve => require(['@/views/User/userdata'], resolve),
      meta: {
        title: '编辑个人资料'
      }
    },
    {
      path: '/user/usercenter',
      name: 'usercenter',
      component: resolve => require(['@/views/User/usercenter'], resolve),
      meta: {
        title: '活动圈用户中心'
      }
    },
    {
      path: '/user/login',
      name: 'login',
      component: resolve => require(['@/views/User/login'], resolve),
      meta: {
        title: '用户登录'
      }
    },
    {
      path: '/user/userinfo',
      name: 'userinfo',
      component: resolve => require(['@/views/User/userinfo'], resolve),
      meta: {
        title: '个人中心'
      }
    },
    {
      path: '/user/imgtest',
      name: 'imgtest',
      component: resolve => require(['@/views/User/imgtest'], resolve),
      meta: {
        title: '图片测试'
      }
    },
    {
      path: '/article/community',
      name: 'community',
      component: resolve => require(['@/views/Article/community'], resolve),
      meta: {
        title: '关注、粉丝'
      }
    },
    {
      path: '/article/hotarticle',
      name: 'hotarticle',
      component: resolve => require(['@/views/Article/hotarticle'], resolve),
      meta: {
        title: '文章广场'
      }
    },
    {
      path: '/article/addarticle',
      name: 'addarticle',
      component: resolve => require(['@/views/Article/addarticle'], resolve),
      meta: {
        title: '发布文章-活动圈'
      }
    },
    {
      path: '/article/artiledetails',
      name: 'artiledetails',
      component: resolve => require(['@/views/Article/artiledetails'], resolve),
      meta: {
        title: '发布文章-活动圈'
      }
    },
    {
      path:'/activity/hotactivity',
      name:'hotactivity',
      component:resolve => require(['@/views/Activity/hotactivity'],resolve),
      meta:{
        title:'活动广场'
      }
    },
    {
      path:'/activity/activityview',
      name:'activityview',
      component:resolve => require(['@/views/Activity/activityview'],resolve),
      meta:{
        title:'活动圈活动'
      }
    },
    {
      path:'/activity/activityjoin',
      name:'activityjoin',
      component:resolve => require(['@/views/Activity/activityjoin'],resolve),
      meta:{
        title:'参加活动'
      }
    },
    {
      path:'/activity/myorder',
      name:'myorder',
      component:resolve => require(['@/views/Activity/myorder'],resolve),
      meta:{
        title:'我的订单'
      }
    },
    {
      path:'/activity/myeticket',
      name:'myeticket',
      component:resolve => require(['@/views/Activity/myeticket'],resolve),
      meta:{
        title:'我的票券'
      }
    },
    {
      path:'/activity/Signin',
      name:'Signin',
      component:resolve => require(['@/views/Activity/Signin'],resolve),
      meta:{
        title:'活动签到'
      }
    },
    {
      path:'/activity/checkticket',
      name:'checkticket',
      component:resolve => require(['@/views/Activity/checkticket'],resolve),
      meta:{
        title:'验票'
      }
    },
    {
      path:'/activity/mysign',
      name:'mysign',
      component:resolve => require(['@/views/Activity/mysign'],resolve),
      meta:{
        title:'我的报名'
      }
    },
    {
      path:'/activity/signinfo',
      name:'signinfo',
      component:resolve => require(['@/views/Activity/signinfo'],resolve),
      meta:{
        title:'报名详情'
      }
    },
    {
      path:'/activity/orderinfo',
      name:'orderinfo',
      component:resolve => require(['@/views/Activity/orderinfo'],resolve),
      meta:{
        title:'订单详情'
      }
    },
    {
      path:'/activity/eticket',
      name:'eticket',
      component:resolve => require(['@/views/Activity/eticket'],resolve),
      meta:{
        title:'活动圈电子票'
      }
    },
    {
      path:'/activity/editactivity',
      name:'editactivity',
      component:resolve => require(['@/views/Activity/editactivity'],resolve),
      meta:{
        title:'编辑活动圈基本信息'
      }
    },
    {
      path: '/account',
      name: 'Account',
      component: resolve => require(['@/views/Account/Account'], resolve),
    },
    {
      path: '/mystudy',
      name: 'Mystudy',
      component: resolve => require(['@/views/Mystudy'], resolve),
    },
    {
      path: '/classify',
      name: 'Classify',
      component: resolve => require(['@/views/Classify'], resolve),
    },
    {
      path: '/home/coursedetails',
      name: 'Coursedetails',
      component: resolve => require(['@/views/Coursedetails/Coursedetails'], resolve),
      // children:[
      //   {
      //     path: '',
      //     redirect: 'introduce'
      //   },
      //   { path: 'introduce', component: introduce, name: 'introduce' },
      //   { path: 'catalog', component: catalog, name: 'catalog' },
      //   { path: 'comment', component:comment, name: 'comment' },
      // ]
    },
    {
      path: '/classifydetails',
      name: 'Classifydetails',
      component: resolve => require(['@/views/Classifydetails'], resolve),
      children:[
      ]
    },
    {
      path: '/home/search',
      name: 'search',
      component: resolve => require(['@/components/search'], resolve),

    },
    {
      path: '/account/login',
      name: 'login',
      component: resolve => require(['@/views/Login'], resolve),
      meta: {
        title: '活动圈-登录',
        auth: true
      }
    },
    {
      path: '/account/forgetpsw',
      name: 'forgetpsw',
      component: resolve => require(['@/views/forgetpsw'], resolve),
      meta: {
        title: '找回密码',
      }
    },
    {
      path: '/account/wxauth',
      name: 'wxauth',
      component: resolve => require(['@/views/WxAuth'], resolve),
      meta: {
        title: '活动圈-微信登录',

      }
    },
    {
      path:'/account/setting',
      component: resolve => require(['@/views/Account/setting'], resolve),
    },
    {
      path: '*',
      name: 'notfound',
      component: resolve => require(['@/components/NotFound'], resolve),
    },
    {
      path: '/reward',
      name: 'reward',
      component: resolve => require(['@/views/Reward/Reward'], resolve),
      meta: {
        title: '加油页面',
      }
    },
    {
      path: '/article/album',
      name: 'album',
      component: resolve => require(['@/views/Article/album'], resolve),
      meta: {
        title: '专辑'
      }
    },
    {
      path: '/user/membership',
      name: 'membership',
      component: resolve => require(['@/views/User/membership'], resolve),
      meta: {
        title: '开通会员'
      }
    },
    {
      path: '/user/test',
      name: 'test124',
      component: resolve => require(['@/views/User/test'], resolve),
      meta: {
        title: '开通会员'
      }
    },
    {
      path: '/user/match',
      name: 'match',
      component: resolve => require(['@/views/User/match'], resolve),
      meta: {
        title: '我的比赛'
      }
    },
    {
      path: '/user/activity',
      name: 'activity',
      component: resolve => require(['@/views/User/activity'], resolve),
      meta: {
        title: '我的活动'
      }
    },
    {
      path: '/user/article',
      name: 'article',
      component: resolve => require(['@/views/User/article'], resolve),
      meta: {
        title: '我的文章'
      }
    },
    {
      path: '/interact/index',
      name: 'interact',
      component: resolve => require(['@/views/Interact/index'], resolve),
      meta: {
        title: '现场互动'
      }
    },
    {
      path: '/interact/signin',
      name: 'signin',
      component: resolve => require(['@/views/Interact/SignIn'], resolve),
      meta: {
        title: '现场互动_签到'
      }
    },
    {
      path: '/interact/danmu',
      name: 'danmu',
      component: resolve => require(['@/views/Interact/danmu'], resolve),
      meta: {
        title: '现场互动_弹幕'
      }
    },
    {
      path: '/interact/luckdraw',
      name: 'luckdraw',
      component: resolve => require(['@/views/Interact/Luckdraw'], resolve),
      meta: {
        title: '现场互动_中奖名单'
      }
    },
    {
      path: '/interact/usersign',
      name: 'usersign',
      component: resolve => require(['@/views/Interact/usersign'], resolve),
      meta: {
        title: '现场互动_签到'
      }
    },
    {
      path: '/interact/PrizeDetails',
      name: 'PrizeDetails',
      component: resolve => require(['@/views/Interact/PrizeDetails'], resolve),
      meta: {
        title: '中奖信息'
      }
    },
    {
      path: '/interact/shake',
      name: 'shake',
      component: resolve => require(['@/views/Interact/shake'], resolve),
      meta: {
        title: '摇一摇'
      }
    },
    {
      path: '/user/myissueact',
      name: 'myissueact',
      component: resolve => require(['@/views/User/myact/myissueact'], resolve),
      meta: {
        title: '活动管理'
      }
    },
    {
      path: '/user/myshareact',
      name: 'myshareact',
      component: resolve => require(['@/views/User/myact/myshareact'], resolve),
      meta: {
        title: '活动管理'
      }
    },
    {
      path: '/comment/review',
      name: 'review',
      component: resolve => require(['@/views/Comment/review'], resolve),
      meta: {
        title: '评论区'
      }
    },
    {
      path: '/clockin/index',
      name: 'clockin',
      component: resolve => require(['@/views/Clockin/index'], resolve),
      meta: {
        title: '早起打卡'
      }
    },
    {
      path: '/clockin/profit',
      name: 'clockinprofit',
      component: resolve => require(['@/views/Clockin/profit'], resolve),
      meta: {
        title: '打卡红包'
      }
    },
    {
      path: '/clockin/mygroup',
      name: 'clockinmygroup',
      component: resolve => require(['@/views/Clockin/mygroup'], resolve),
      meta: {
        title: '我的打卡团'
      }
    },
    {
      path: '/clockin/groupindex',
      name: 'groupindex',
      component: resolve => require(['@/views/Clockin/groupindex'], resolve),
      meta: {
        title: '打卡团'
      }
    },
    {
      path: '/clockin/groupinfo',
      name: 'groupinfo',
      component: resolve => require(['@/views/Clockin/groupinfo'], resolve),
      meta: {
        title: '打卡团资料'
      }
    },
    {
      path: '/clockin/installedgroup',
      name: 'installedgroup',
      component: resolve => require(['@/views/Clockin/installedgroup'], resolve),
      meta: {
        title: '打卡团设置'
      }
    },
    {
      path: '/clockin/groupadmin',
      name: 'groupadmin',
      component: resolve => require(['@/views/Clockin/groupadmin'], resolve),
      meta: {
        title: '打卡团管理'
      }
    },
    {
      path: '/clockin/groupmember',
      name: 'groupmember',
      component: resolve => require(['@/views/Clockin/groupmember'], resolve),
      meta: {
        title: '打卡团成员'
      }
    },
    {
      path: '/clockin/myclockin',
      name: 'myclockin',
      component: resolve => require(['@/views/Clockin/myclockin'], resolve),
      meta: {
        title: '我的打卡'
      }
    },
    {
      path: '/clockin/clockincard',
      name: 'clockincard',
      component: resolve => require(['@/views/Clockin/clockincard'], resolve),
      meta: {
        title: '我的补签卡'
      }
    },
    {
      path: '/clockin/hotgroup',
      name: 'hotgroup',
      component: resolve => require(['@/views/Clockin/hotgroup'], resolve),
      meta: {
        title: '打卡团广场'
      }
    },
    {
      path: '/clockin/newgroup',
      name: 'newgroup',
      component: resolve => require(['@/views/Clockin/newgroup'], resolve),
      meta: {
        title: '创建打卡团'
      }
    },
    {
      path: '/clockin/signclockin',
      name: 'signclockin',
      component: resolve => require(['@/views/Clockin/signclockin'], resolve),
      meta: {
        title: '早起打卡'
      }
    },
    {
      path: '/clockin/poster',
      name: 'poster',
      component: resolve => require(['@/views/Clockin/poster'], resolve),
      meta: {
        title: '早起打卡海报'
      }
    },
    {
      path: '/clockin/remind',
      name: 'remind',
      component: resolve => require(['@/views/Clockin/remind'], resolve),
      meta: {
        title: '早安提醒'
      }
    },
    {
      path:'/groupbuy/activityview',
      name:'activityview',
      component:resolve => require(['@/views/Groupbuy/activityview'],resolve),
      meta:{
        title:'活动圈团购'
      }
    },
    {
      path:'/groupbuy/activityview1',
      name:'activityview1',
      component:resolve => require(['@/views/Groupbuy/activityview1'],resolve),
      meta:{
        title:'活动圈团购'
      }
    },
    {
      path:'/groupbuy/captainauth',
      name:'captainauth',
      component:resolve => require(['@/views/Groupbuy/captainauth'],resolve),
      meta:{
        title:'团长认证申请'
      }
    },
    {
      path:'/groupbuy/groupapply',
      name:'groupapply',
      component:resolve => require(['@/views/Groupbuy/groupapply'],resolve),
      meta:{
        title:'开团申请'
      }
    },
    {
      path:'/groupbuy/groupview',
      name:'groupview',
      component:resolve => require(['@/views/Groupbuy/groupview'],resolve),
      meta:{
        title:'社区团购'
      }
    },
    {
      path:'/groupbuy/groupview1',
      name:'groupview1',
      component:resolve => require(['@/views/Groupbuy/groupview1'],resolve),
      meta:{
        title:'社区团购'
      }
    },
    {
      path:'/groupbuy/groupjoin',
      name:'groupjoin',
      component:resolve => require(['@/views/Groupbuy/groupjoin'],resolve),
      meta:{
        title:'团购商品'
      }
    },
    {
      path:'/groupbuy/groupjoin1',
      name:'groupjoin1',
      component:resolve => require(['@/views/Groupbuy/groupjoin1'],resolve),
      meta:{
        title:'团购商品'
      }
    },
    {
      path:'/groupbuy/index',
      name:'hotactivity',
      component:resolve => require(['@/views/Groupbuy/hotactivity'],resolve),
      meta:{
        title:'团购商品'
      }
    },
    {
      path:'/groupbuy/orderinfo',
      name:'orderinfo',
      component:resolve => require(['@/views/Groupbuy/orderinfo'],resolve),
      meta:{
        title:'订单详情'
      }
    },
    {
      path:'/groupbuy/myorder',
      name:'myorder',
      component:resolve => require(['@/views/Groupbuy/myorder'],resolve),
      meta:{
        title:'我的订单'
      }
    },
    {
      path:'/groupbuy/mygroup',
      name:'mygroup',
      component:resolve => require(['@/views/Groupbuy/mygroup'],resolve),
      meta:{
        title:'我的团'
      }
    },
    {
      path:'/groupbuy/usercenter',
      name:'usercenter',
      component:resolve => require(['@/views/Groupbuy/g_userinfo'],resolve),
      meta:{
        title:'个人中心'
      }
    },
    {
      path:'/groupbuy/teambuyinfo',
      name:'teambuyinfo',
      component:resolve => require(['@/views/Groupbuy/teambuyinfo'],resolve),
      meta:{
        title:'个人中心'
      }
    },
    {
      path:'/home/luckywheel',
      name:'orderinfo',
      component:resolve => require(['@/views/Home/luckywheel'],resolve),
      meta:{
        title:'大转盘抽奖'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js